import { render, staticRenderFns } from "./rake-back-skeleton.vue?vue&type=template&id=4f9a76a5&scoped=true&lang=pug&"
import script from "./rake-back-skeleton.vue?vue&type=script&lang=js&"
export * from "./rake-back-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./rake-back-skeleton.vue?vue&type=style&index=0&id=4f9a76a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a76a5",
  null
  
)

export default component.exports